const App = function (config) {
    config = config || {};

    let _this = this;

    this.elms = {};
    this.elms.$wrap = jQuery('#' + config.wrapId);
    this.elms.$list = this.elms.$wrap.find("UL");

    this.elms.$list.html("");

    let duration = config.duration;

    let create = {
        item: function (text, type) {
            let factory = {
                text: function () {
                    switch (type) {
                        case "danger":
                            return "The operation has encountered an error.";
                        case "success":
                        case "warning":
                        case "info":
                        case "message":
                        default:
                            return "The operation was successful.";
                    }
                }
            };
            let html = "";

            html += "<li class=\"<!--type-->\">";
            html += "<span>";

            html += "<!--message--><span class='toast__progress'>";
            html += "<span style='animation-duration: " + ((duration + 300)/1000) + "s' class='toast__progress-bar'>";
            html += "</span>";
            html += "</span>";
            html += "</span>";
            html += "</li>";

            html = html.replace(/<!--type-->/, type || "default")
                .replace(/<!--message-->/, text || factory.text());

            return { jq: jQuery(html), html: html };
        },
        wrap: function () {
            let html = "<div id='toast' class=\"toast\"><ul></ul></div>";

            return { jq: jQuery(html), html: html };
        }
    };

    let close = function (toast) {
        let $toast = jQuery(toast);

    };

    let hide = function () {
        let $toast = _this.$toast;

        setTimeout(function () { $toast.removeClass("show") }, duration + 300);
        setTimeout(function () { $toast.remove() }, duration + 600);
        $toast.on("click", function () {
            $toast.removeClass("show");
            setTimeout(function () { $toast.remove() }, 300);
        });
    };

    this.hide = function (toast) {
        toast.removeClass("show");
        setTimeout(function () { toast.remove() }, 300);
    };

    let show = function ($toast, autoHide) {
        let width = _this.elms.$wrap.outerWidth(true);
        $toast.css("width", width);
        setTimeout(function () { $toast.addClass("show"); }, 300);

        _this.$toast = $toast;

        if(autoHide !== false) {
            hide();       // Automatically hide toast item
        }
    };

    let append = function (message, type, callback, autoHide) {
        let $toast = create.item(message, type).jq;
        _this.elms.$list.append($toast);

        show($toast, autoHide);

        callback && callback();

        return $toast;
    };

    this.success = function (message, callback, autoHide) {
        return append(message, "success", callback, autoHide);
    };
    this.danger = function (message, callback, autoHide) {
        return append(message, "danger", callback, autoHide);
    };
    this.warning = function (message, callback, autoHide) {
        return append(message, "warning", callback, autoHide);
    };
    this.info = function (message, callback, autoHide) {
        return append(message, "info", callback, autoHide);
    };
    this.message = function (message, callback, autoHide) {
        return append(message, "warning", callback, autoHide);
    };
    this.progress = function (message, callback, autoHide) {
        return append(message, "warning progress", callback, autoHide);
    };

    this.init = function () {
        if (this.elms.$wrap && !this.elms.$wrap.length) {
            this.elms.$wrap = create.wrap().jq;
            jQuery(document.body).append(this.elms.$wrap);
            this.elms.$list = this.elms.$wrap.find("UL");
        }

        return this;
    };

    return this;
};

export const toast = new App({ wrapId: "toast", duration: 5000 }).init();